import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const CityField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.AddressLevel2} field={FIELD_NAMES.CITY} optional={optional} />;
};

CityField.propTypes = {
  optional: PropTypes.bool,
};
